












import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CloseButton extends Vue {
  @Prop({ type: Function, required: true }) private onClick!: () => void;
}
